document.addEventListener('DOMContentLoaded', () => {
    const profile = document.querySelector('.profile');
    const headerMenu = document.querySelector('.header_menu ul'); // предполагается, что это ul внутри меню
    const originalParent = profile?.parentElement;
  
    const moveProfileIfNeeded = () => {
      if (!profile || !headerMenu || !originalParent) return;
  
      if (window.innerWidth <= 768) {
        if (!headerMenu.contains(profile)) {
          headerMenu.appendChild(profile); // Переместить в меню
        }
      } else {
        if (!originalParent.contains(profile)) {
          originalParent.insertBefore(profile, originalParent.querySelector('.theme-switch')); // Вернуть на место
        }
      }
    };
  
    // Сразу при загрузке
    moveProfileIfNeeded();
  
    // При изменении размера окна
    window.addEventListener('resize', moveProfileIfNeeded);
  });